import PropTypes from 'prop-types';
import React from 'react';
import { Notification as NotificationRecord } from '@xanadu/ui-shared/modules/application/reducer';
import styles from './Notification.module.scss';

const Notification = ({
  notification,
  dismiss,
}) => {
  const { title, description, visible, action } = notification;

  const handleClick = () => {
    if (typeof action === 'function') {
      dismiss();
      action();

      return;
    }

    dismiss();
  };

  const mainClass = [
    styles.main,
    !visible ? styles['main--hidden'] : '',
  ].join(' ');

  return (
    <div
      role="button"
      className={mainClass}
      onClick={handleClick}
    >
      <span className={styles.title}>{title}</span>
      <span className={styles.description}>{description}</span>
    </div>
  );
};


Notification.propTypes = {
  notification: PropTypes.instanceOf(NotificationRecord).isRequired,
  dismiss: PropTypes.func.isRequired,
};

export default Notification;
